export const computeRange = (number: number, result: number[] = []): number[] => {
  if (result.length === number) return result;
  const returnValue = computeRange(number, [...result, result.length]);
  return returnValue.filter(Boolean);
};

export const getRange = (end: number) => {
  const start = 1;
  const length = end;
  return Array.from({ length }, (_, i) => start + i);
};
